import { Component } from '@angular/core';


@Component({
    selector: 'app-visualizacion-informacion',
    templateUrl: './visualizacion-informacion.component.html',
    styleUrls: ['visualizacion-informacion.scss']
})
export class VisualizacionInformacionComponent {

    constructor() { }

}
